import { c as _c } from "react/compiler-runtime";
import type { ItemQuantityPriceDto } from "@sticker-giant/sg-frontend-common";
import { SelectItem, SelectSeparator } from "@/components/ui/select";
import QuantityOption from "./QuantityOption";
interface CustomQuantityItem {
  quantity: number;
  pricing?: ItemQuantityPriceDto;
}
interface Props {
  quantityOptions: number[];
  priceMap: Map<number, ItemQuantityPriceDto>;
  allowCustomQuantity: boolean;
  customQuantityLabel: string;
  confirmedCustom?: CustomQuantityItem;
}
export default function QuantitySelectItems(t0) {
  const $ = _c(19);
  const {
    quantityOptions,
    priceMap,
    allowCustomQuantity,
    customQuantityLabel,
    confirmedCustom
  } = t0;
  let t1;
  if ($[0] !== confirmedCustom || $[1] !== quantityOptions) {
    t1 = confirmedCustom && !quantityOptions.includes(confirmedCustom.quantity);
    $[0] = confirmedCustom;
    $[1] = quantityOptions;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const showCustomItem = t1;
  let t2;
  if ($[3] !== priceMap || $[4] !== quantityOptions) {
    let t3;
    if ($[6] !== priceMap) {
      t3 = qty => {
        const pricing = priceMap.get(qty);
        return <SelectItem key={qty} value={String(qty)}>{pricing ? <QuantityOption quantity={qty} pricePerUnit={pricing.pricePerUnit} price={pricing.price} /> : qty.toLocaleString()}</SelectItem>;
      };
      $[6] = priceMap;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = quantityOptions.map(t3);
    $[3] = priceMap;
    $[4] = quantityOptions;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[8] !== confirmedCustom || $[9] !== showCustomItem) {
    t3 = showCustomItem && <><SelectSeparator /><SelectItem value={confirmedCustom.quantity.toString()}>{confirmedCustom.pricing ? <QuantityOption quantity={confirmedCustom.quantity} label={confirmedCustom.quantity.toLocaleString()} pricePerUnit={confirmedCustom.pricing.pricePerUnit} price={confirmedCustom.pricing.price} /> : `${confirmedCustom.quantity.toLocaleString()}`}</SelectItem></>;
    $[8] = confirmedCustom;
    $[9] = showCustomItem;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== allowCustomQuantity || $[12] !== customQuantityLabel || $[13] !== showCustomItem) {
    t4 = allowCustomQuantity && !showCustomItem && <><SelectSeparator /><SelectItem value="custom">{customQuantityLabel}</SelectItem></>;
    $[11] = allowCustomQuantity;
    $[12] = customQuantityLabel;
    $[13] = showCustomItem;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
    t5 = <>{t2}{t3}{t4}</>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}